// extracted by mini-css-extract-plugin
export default {"container":"src-components-Antd-Rate-css-module__container--DmKlp","ratingText":"src-components-Antd-Rate-css-module__ratingText--k1duq"};